import { DataBean } from "../DataBean";



export class CreateProcess extends DataBean {
    
    


    public async createProcess(idCustomProcessType:any,accountantDate:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "admin.Process_createProcess_Number_java.util.Date_Number", [idCustomProcessType,accountantDate,idEmployee]);
    }
    public async getProcessReport(idProcess:any,processDate:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProcessReport_Number_java.util.Date_Number", [idProcess,processDate,idEmployee]);
    }

    public async getProcessCatalog(processType:any,year:any,subType:any,fromMonth:any,uptoMonth:any,idCustomProcessType:any,state:any,idEmployee:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getProcessCatalog_Number_Number_Number_Number_Number_Number_Number_Number_Number_Number", [processType,year,subType,fromMonth,uptoMonth,idCustomProcessType,state,idEmployee,page,recordsPerPage]);
    }

    public async getProcessStateConstants(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProcessStateConstants_Number", [id]);
    }
    public async validateErrosPaymentHeaderByIdProcess(idProcess:number): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_validateErrosPaymentHeaderByIdProcess_Number", [idProcess]);
    }




}